import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import { FaBan } from "react-icons/fa";
import {
  postDataWithBody,
} from "../../../Services/Services";
import {
  CancelSopInstance,
} from "../../../Services/EndPoints";
import { toast } from "react-toastify";
import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from "react-router-dom";
import "./TaskModalWithCommentSop.css";

const CANCELLATION_REASONS = [
  "False Alert",
  "Duplicate SOP",
  "Wrong Disaster",
  "Wrong Severity",
  "Incident Cancelled",
  "SOP Triggered by Mistake",
  "Resource Mapping Issue",
  "Other",
];

const TaskModalWithCommentSopCancel = (props) => {
  const {
    titleValue,
    show,
    setShowPop,
    taskData,
  } = props;

  const [cancelReason, setCancelReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  const isValid = cancelReason.trim().length > 0 && remarks.trim().length > 0;

  const handleClose = () => {
    setShowPop(false);
    setCancelReason("");
    setRemarks("");
  };

  async function saveConfigData() {
    if (!isValid) {
      return;
    }

    setIsSaving(true);
    try {
      const input = {
        sopInstanceId: taskData.id,
        cancelReason: cancelReason,
        remarks: remarks,
        cancelledBy: keycloak.idTokenParsed?.email,
      };

      const res = await postDataWithBody(CancelSopInstance, input, {});

      if (res && res.status === "success") {
        toast.success(res.msg || "SOP instance cancelled successfully", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        handleClose();
        navigate("../Sop-instance-list");
      } else {
        toast.error(res?.msg || "Failed to cancel SOP instance", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        handleClose();
        navigate("/resource-assign-list");
      }
    } catch (error) {
      console.error("Error cancelling SOP instance:", error);
      toast.error("An error occurred while cancelling the SOP instance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className="table__modal__popup task-action-modal"
        centered
        enforceFocus={false}
      >
        <Modal.Header>
          <Modal.Title>
            <span className="task-icon-badge">
              <FaBan size={14} color="#fff" />
            </span>
            {titleValue || "Cancel SOP Instance"}
          </Modal.Title>
          <span className="task-close-btn" onClick={handleClose}>
            <XCircleblack style={{ color: "#fff" }} width="1.1em" height="1.1em" />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <span className="task-label">
              Cancellation Reason <span style={{ color: "#e74c3c" }}>*</span>
            </span>
            <select
              className="task-select"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
            >
              <option value="">-- Select a reason --</option>
              {CANCELLATION_REASONS.map((reason) => (
                <option key={reason} value={reason}>{reason}</option>
              ))}
            </select>

            <div className="mt-3">
              <span className="task-label">
                Remarks <span style={{ color: "#e74c3c" }}>*</span>
              </span>
              <textarea
                placeholder="Enter remarks"
                className="task-textarea"
                id="modal_cancel_remarks_txt_area"
                value={remarks}
                maxLength={250}
                onChange={(e) => setRemarks(e.target.value)}
                rows={4}
              />
              <div className="task-counter">{remarks.length}/250</div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={handleClose}
            type="button"
            style={{
              padding: "7px 20px", borderRadius: "8px", border: "1px solid #adb5bd",
              background: "#fff", color: "#333", fontSize: "13px", cursor: "pointer", fontWeight: "500",
            }}
          >
            Cancel
          </button>
          <button
            onClick={saveConfigData}
            type="button"
            className="btn-save"
            disabled={!isValid || isSaving}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TaskModalWithCommentSopCancel;
